var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3050_27953)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.43934 0.93934C0.720644 0.658035 1.10218 0.5 1.5 0.5H11.5C11.8978 0.5 12.2794 0.658036 12.5607 0.93934C12.842 1.22064 13 1.60217 13 2V13.5C13 13.7652 13.1054 14.0196 13.2929 14.2071C13.4804 14.3946 13.7348 14.5 14 14.5C14.2652 14.5 14.5196 14.3946 14.7071 14.2071C14.8946 14.0196 15 13.7652 15 13.5V4C15 3.72386 15.2239 3.5 15.5 3.5C15.7761 3.5 16 3.72386 16 4V13.5C16 14.0304 15.7893 14.5391 15.4142 14.9142C15.0391 15.2893 14.5304 15.5 14 15.5H2C1.46957 15.5 0.960859 15.2893 0.585786 14.9142C0.210714 14.5391 0 14.0304 0 13.5V2C0 1.60218 0.158035 1.22064 0.43934 0.93934ZM12.2679 14.5C12.0939 14.1985 12 13.8541 12 13.5V2C12 1.86739 11.9473 1.74022 11.8536 1.64645C11.7598 1.55268 11.6326 1.5 11.5 1.5H1.5C1.36739 1.5 1.24021 1.55268 1.14645 1.64645C1.05268 1.74021 1 1.86739 1 2V13.5C1 13.7652 1.10536 14.0196 1.29289 14.2071C1.48043 14.3946 1.73478 14.5 2 14.5H12.2679Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10C2.5 9.72386 2.72386 9.5 3 9.5H10C10.2761 9.5 10.5 9.72386 10.5 10C10.5 10.2761 10.2761 10.5 10 10.5H3C2.72386 10.5 2.5 10.2761 2.5 10Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 12C2.5 11.7239 2.72386 11.5 3 11.5H7C7.27614 11.5 7.5 11.7239 7.5 12C7.5 12.2761 7.27614 12.5 7 12.5H3C2.72386 12.5 2.5 12.2761 2.5 12Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4C2.5 3.44772 2.94772 3 3.5 3H9.5C10.0523 3 10.5 3.44772 10.5 4V7C10.5 7.55229 10.0523 8 9.5 8H3.5C2.94772 8 2.5 7.55229 2.5 7V4ZM9.5 4H3.5V7H9.5V4Z",
    fill: "#64748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3050_27953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.1affdafa29c9ae6223c87d32271afd54.svg";
export { ForwardRef as ReactComponent };